import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English", short: "EN" },
  { code: "pl", label: "Polski", short: "PL" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const langCode = i18n.language.split("-")[0];
  const current = languages.find((l) => l.code === langCode) ?? languages[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50/80 px-3 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        {current.short}
        <span className="w-4 h-4 flex items-center justify-center">
          <i className={`${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-base`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-foreground-200 bg-background-50 py-1">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-4 py-2 text-sm transition-colors hover:bg-background-100 ${
                l.code === langCode ? "font-semibold text-primary-700" : "text-foreground-700"
              }`}
            >
              {l.label}
              {l.code === langCode && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-base"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}